import {
  Body1,
  Caption1,
  makeStyles,
  mergeClasses,
  tokens,
} from '@fluentui/react-components';
import type { ReactNode } from 'react';

const useStyles = makeStyles({
  list: {
    display: 'grid',
    gridTemplateColumns: 'minmax(140px, auto) minmax(0, 1fr)',
    rowGap: tokens.spacingVerticalM,
    columnGap: tokens.spacingHorizontalL,
    margin: 0,
    padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalL} ${tokens.spacingVerticalL}`,
  },
  label: { color: tokens.colorNeutralForeground3 },
  value: { margin: 0, minWidth: 0, overflowWrap: 'anywhere' },
  // Ids e códigos: fonte de largura fixa, fáceis de conferir e copiar.
  mono: { fontFamily: tokens.fontFamilyMonospace },
  empty: { color: tokens.colorNeutralForeground4 },
});

export interface DataRow {
  readonly label: string;
  /** `null`: a fonte não trouxe o dado. */
  readonly value: ReactNode;
  /** Ids, códigos e chaves, em fonte de largura fixa. */
  readonly mono?: boolean;
}

/** Pares rótulo e valor, como os dados de um cartão de detalhe. */
export function DataList({ rows }: { rows: readonly DataRow[] }) {
  const styles = useStyles();
  return (
    <dl className={styles.list}>
      {rows.map(({ label, value, mono = false }) => (
        <div key={label} style={{ display: 'contents' }}>
          <dt>
            <Caption1 className={styles.label}>{label}</Caption1>
          </dt>
          <dd className={styles.value}>
            {value === null || value === '' ? (
              <Body1 className={styles.empty}>Não informado</Body1>
            ) : (
              <Body1 className={mergeClasses(mono && styles.mono)}>
                {value}
              </Body1>
            )}
          </dd>
        </div>
      ))}
    </dl>
  );
}
